import { c, t } from "ttag";

import type { LengthParams, MaxLengthParams } from "./types";

export const required = () => t`This field is required`;

export const email = () => t`Please enter a valid email address`;

export const maxLength = ({ max }: MaxLengthParams) =>
  c("{0} is a number greater than 1").t`Please use ${max} characters or fewer`;

export const exactLength = ({ length }: LengthParams) =>
  c("{0} is a number greater than 1")
    .t`Please use exactly ${length} characters`;

export const positive = () => t`Please enter a positive integer value`;
